import { render } from "./courseInfoXb.vue?vue&type=template&id=705f07fc&scoped=true"
import script from "./courseInfoXb.vue?vue&type=script&lang=js"
export * from "./courseInfoXb.vue?vue&type=script&lang=js"

import "./courseInfoXb.vue?vue&type=style&index=0&id=705f07fc&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-705f07fc"]])

export default __exports__